const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#670001',
                hover: '#590708'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
